import gql from 'graphql-tag';

export default gql`
  query TEAM_REGISTRATION_GENERATE_ID {
    teamRegistrationGenerateId
  }
`
